<template>
  <div class="mb-3">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col class="pb-3" align="right">
              <b-button variant="outline-success" @click="agregar()"
                >Agregar datos fiscales
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row align="center" v-if="loader">
        <b-col>
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-if="!loader">
        <b-col
          v-for="(dato, index) in datosFiscales"
          :key="dato.rcf + index"
          cols="6"
        >
          <b-card
            :title="dato.rfc"
            tag="article"
            style="width: 100%; color: gray"
            class="mb-2"
          >
            <b-card-text style="color: gray" class="text-left">
              <p>{{ dato.nombreCompleto }}</p>
              <p v-if="dato.tipoPersona === 2">Persona fisica</p>
              <p v-else>Persona Moral</p>
              <p>{{ dato.correo }}</p>
              <p>
                {{
                  (dato.calle != null ? dato.calle : "") +
                  (dato.numero != null ? ", #" + dato.numero : "") +
                  (dato.colonia != null ? ", " + dato.colonia : "") +
                  (dato.estado != null ? ", " + dato.estado : "")
                }}
              </p>
            </b-card-text>

            <b-button
              type="button"
              @click="modificar(dato)"
              variant="outline-warning"
              >Editar
            </b-button>
            <b-button
              v-if="dato.activo"
              type="button"
              @click="eliminar(dato)"
              variant="outline-danger"
              >Desactivar
            </b-button>
            <b-button
              v-else
              type="button"
              @click="eliminar(dato)"
              variant="outline-secondary"
              >Activar
            </b-button>
          </b-card>
        </b-col>
        <b-col v-if="datosFiscales.length === 0">
          <b-alert variant="warning" show>Sin datos fiscales</b-alert>
        </b-col>
      </b-row>
    </b-container>
    <b-modal v-model="showModal" :title="titulo" size="lg" centered>
      <div fluid>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group
                @input="listaFiscal"
                id="tipo"
                v-model="datoFiscal.tipoPersona"
                name="tipo"
              >
                <b-form-radio :value="2">Fisica</b-form-radio>
                <b-form-radio :value="1">Moral</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="rfc"
                >RFC
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="rfc"
                  name="rfc"
                  placeholder="RFC"
                  v-model="$v.datoFiscal.rfc.$model"
                  @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                  :state="validateState('rfc')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="regimen"
                >Regimen Fiscal
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-select
                  id="regimen"
                  name="regimen"
                  placeholder="Regimen Fiscal"
                  v-model="$v.datoFiscal.regimenFiscal.$model"
                  :options="regimenFiscales"
                  value-field="idRegimenFiscal"
                  text-field="nombre"
                  :state="validateState('regimenFiscal')"
                ></b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <h5>Razón social</h5>
        <hr />
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="nombre"
                >Nombre(s)
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="type"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  v-model="$v.datoFiscal.nombre.$model"
                  :state="validateState('nombre')"
                  id="nombre"
                  name="nombre"
                  placeholder="Nombre"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 1">
          <b-col>
            <b-form-group>
              <label for="nombre"
                >Nombre de la razón social
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="type"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  v-model="$v.datoFiscal.nombreCompleto.$model"
                  :state="validateState('nombreCompleto')"
                  id="nombreCompleto"
                  name="nombreCompleto"
                  placeholder="Nombres"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="paterno"
                >Apellido paterno
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="type"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="paterno"
                  name="paterno"
                  placeholder="Apellido paterno"
                  v-model="$v.datoFiscal.paterno.$model"
                  :state="validateState('paterno')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="materno"
                >Apellido materno
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="type"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="materno"
                  name="materno"
                  placeholder="Apellido materno"
                  v-model="$v.datoFiscal.materno.$model"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="correo"
                >Correo electrónico
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="envelope"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="email"
                  id="correo"
                  name="correo"
                  placeholder="Correo"
                  v-model="$v.datoFiscal.correo.$model"
                  :state="validateState('correo')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5>
              Dirección
              <span class="text-secondary"><small>(Opcional)</small></span>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="calle">Calle </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <em class="fa fa-road"></em>
                </b-input-group-prepend>
                <b-form-input
                  id="calle"
                  name="calle"
                  placeholder="Calle"
                  v-model="datoFiscal.calle"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="numero">Número </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <em class="fa fa-hashtag"></em>
                </b-input-group-prepend>
                <b-form-input
                  id="numero"
                  name="numero"
                  placeholder="Número"
                  v-model="datoFiscal.numero"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="cp">CP </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <em class="fa fa-hashtag"></em>
                </b-input-group-prepend>
                <b-form-input
                  id="cp"
                  name="cp"
                  placeholder="CP"
                  v-model="$v.datoFiscal.cp.$model"
                  :state="validateState('cp') && this.localidades.length > 0"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="colonia">Colonia </label>

              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="filter-square"></b-icon>
                </b-input-group-prepend>

                <v-select
                  id="colonia"
                  style="width: 90%"
                  name="colonia"
                  label="nombreLocalidad"
                  placeholder="Selecciona una colonia"
                  v-model="$v.datoFiscal.colonia.$model"
                  :reduce="(nom) => nom.nombreLocalidad"
                  :options="localidades"
                ></v-select>
              </b-input-group>
              <b-form-invalid-feedback
                v-if="tieneCp && this.localidades.length > 0"
                :state="datoFiscal.colonia != null">
                Selecciona una colonia
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="pais">País de residencia </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="house"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="pais"
                  name="pais"
                  placeholder="País"
                  v-model="datoFiscal.pais"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="estado">Estado </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="house"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="estado"
                  name="estado"
                  placeholder="Estado"
                  v-model="datoFiscal.estado"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="guardar()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
//importando otras tabs

import {
  maxLength,
  numeric,
  required,
  email,
  minLength,
} from "vuelidate/lib/validators";

export default {
  name: "prosecutors",
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    datosFiscales: [],
    fields: [
      { key: "idMenu", label: "ID", sortable: true },
      { key: "nombreMenu", label: "Nombre", sortable: true },
      "Acciones",
    ],
    regimenFiscales: [],
    idPaciente: null,
    registrosPorPagina: 10,
    paginaActual: 0,
    showModal: false,
    titulo: null,
    loaderAcciones: false,
    loader: false,
    datoFiscal: {
      idPaciente: null,
      idDatosFiscales: null,
      nacionalidad: null,
      rfc: null,
      tipoPersona: 1,
      nombre: null,
      nombreCompleto: null,
      paterno: null,
      materno: null,
      calle: null,
      numero: null,
      colonia: null,
      cp: null,
      pais: null,
      estado: null,
      correo: null,
      regimenFiscal: null,
    },
    localidades: [],
    tieneCp: false,
  }),
  validations() {
    if (this.datoFiscal.tipoPersona === 2) {
      return {
        datoFiscal: {
          rfc: { required, minLength: minLength(13), maxLength: maxLength(13) },
          regimenFiscal: { required },
          nombre: { required },
          paterno: { required },
          materno: {  },
          correo: { required, email },
          cp: {
            numeric,
            minLength: minLength(5),
            maxLength: maxLength(5),
            required,
          },
          colonia: { required },
        },
      };
    } else {
      return {
        datoFiscal: {
          rfc: { required, minLength: minLength(12), maxLength: maxLength(12) },
          regimenFiscal: { required },
          nombreCompleto: { required },
          correo: { required, email },
          cp: {
            numeric,
            minLength: minLength(5),
            maxLength: maxLength(5),
            required,
          },
          colonia: { required },
        },
      };
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente = this.$route.params.id;
    this.obtenerListaDatos();
    this.listaFiscal();
  },
  methods: {
    listaFiscal() {
      const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
      this.$http
        .post(
          this.$api +
            "catalogos/regimenFiscal/obtener/activo", parametros
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.regimenFiscales = respuesta.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        });
    },

    agregar() {
      this.datoFiscal = {
        idPaciente: this.idPaciente,
        idDatosFiscales: null,
        nacionalidad: 1,
        tipoPersona: 1,
        nombre: null,
        nombreCompleto: null,
        rfc: null,
        regimen: null,
        paterno: null,
        materno: null,
        calle: null,
        numero: null,
        colonia: null,
        cp: null,
        pais: null,
        estado: null,
        correo: null,
        regimenFiscal: null,
      };
      this.titulo = "Agregar datos Fiscales";
      this.showModal = true;
    },
    obtenerListaDatos() {
      this.loader = true;
      this.datosFiscales = [];
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "fiscales/obtener/datosFiscales", params  )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosFiscales = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    guardar() {
      this.$v.datoFiscal.$touch();
      if (this.$v.datoFiscal.$anyError) {
        return;
      }
      if (!this.$v.datoFiscal.$invalid) {
        this.loaderAcciones = true;
        this.nombre();
        this.$http
          .post(this.$api + "fiscales/guardar/datosFiscales", this.datoFiscal)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.obtenerListaDatos();
              this.showModal = false;
              this.$swal.fire({
                icon: "success",
                title: "Muy Bien",
                text: "¡Los datos se guardaron correctamente!",
              });
            }
          })
          .catch((reason) => {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: reason.response.data.message,
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    nombre() {
      if (this.datoFiscal.tipoPersona === 1) {
        this.datoFiscal.nombre = "";
        this.datoFiscal.paterno = "";
        this.datoFiscal.materno = "";
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimStart();
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimEnd();
      } else {
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimStart();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimStart();
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimEnd();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimEnd();
        if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trimStart();
          this.datoFiscal.materno = this.datoFiscal.materno.trimEnd();
        }
      }
    },
    modificar(item) {
      this.titulo = "Modificar datos fiscales";
      this.datoFiscal = item;
      this.listaFiscal();
      this.showModal = true;
    },
    eliminar(item) {
      this.$http
        .post(
          this.$api +
            "fiscales/eliminar/datosFiscales",
            item.idDatosFiscales
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            item.activo = !item.activo;
          }
        });
    },
    cerrarModal() {
      this.showModal = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.datoFiscal[name];
      return $dirty ? !$error : null;
    },
    buscarCp() {
      const params = {
        codigoPostal: this.datoFiscal.cp
      }
      this.$http
        .post(this.$api + "localidad/postales", params)
        .then((respuesta) => {
          if (respuesta.status === 200) {
            if (respuesta.data.data.length > 0) {
              this.localidades = respuesta.data.data;
              this.datoFiscal.estado = this.localidades[0].nombreEstado;
              this.datoFiscal.pais = "MÉXICO";
            }
          }
        });
    },
  },
  watch: {
    "datoFiscal.cp": function () {
      if (this.datoFiscal.cp.length === 5) {
        this.tieneCp = true;
        this.buscarCp();
      } else {
        this.tieneCp = false;
        this.localidades = [];
        this.datoFiscal.colonia = null;
        this.datoFiscal.estado = null;
        this.datoFiscal.pais = null;
      }
    },
  },
};
</script>

<style scoped></style>
